import { IoRadioButtonOnOutline } from "react-icons/io5";
import RegionCreateModal from "../Modal/RegionCreateModal";
import RegionListPage from "./RegionListPage";

const columns = [
  { header: "Circle Name", key: "circle" },
  { header: "Circle Id", key: "circleId" },
  { header: "State", key: "state" },
  { header: "Division", viewKey: "divisionList", viewTitle: "Division List" },
  { header: "Created By", key: "createdBy" },
  { header: "Location Description", key: "locationDescription" },
];

const Circle = () => (
  <RegionListPage
    field="circle"
    label="Circle"
    viewTab="Circle"
    CreateIcon={IoRadioButtonOnOutline}
    createLabel="Create New Circle"
    columns={columns}
    renderCreate={(p) => (
      <RegionCreateModal
        {...p}
        tab="Circle"
        fieldName1="Circle Name"
        fieldName2="Choose Division"
      />
    )}
  />
);

export default Circle;